import { useCallback, useState } from "react";
import { logError } from "@entrilia/shared/logging.ts";
import { useBiApiClientProvider } from "../../../sv/contexts/BiApiClientProviderContext.ts";
import type { Props } from "./SaveReportForm.tsx";
import SaveReportForm from "./SaveReportForm.tsx";

interface SaveReportFormWrapperProps extends Props {
  newReport?: boolean;
}
export default function SaveReportFormWrapper(props: SaveReportFormWrapperProps) {
  const { validateName } = useBiApiClientProvider();
  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);

  const validateReportName = useCallback(
    async (name: string) => {
      if (!props.showName) return true;
      setSaving(true);
      try {
        const reportId = props.newReport ? undefined : props.report.reportId;
        const result = await validateName({ reportId, name, clientCode: props.report.clientCode });
        if (!result.success || result.error) {
          setError("An error occurred while renaming the report.");
          return false;
        }
        if (result.success && result.data.nameExists === true) {
          setError("A report with this name already exists");
          return false;
        }
        return true;
      } catch (e) {
        logError(e, "[SaveReportFormWrapper] validateReportName");
        setError("An error occurred while renaming the report.");
        return false;
      } finally {
        setSaving(false);
      }
    },
    [props, validateName]
  );

  const handleSave = useCallback(
    async (name: string, groupId: string) => {
      if (!(await validateReportName(name))) return;
      props.onSave(name, groupId);
    },
    [props, validateReportName]
  );

  return <SaveReportForm {...props} error={error || props.error} saving={saving || props.saving} onSave={handleSave} />;
}
